import { QuoteTemplateAuditLog } from "js/jsx/src/classes/admin/Templates/QuoteTemplateAuditLog.jsx";
import { DialogManager } from "js/jsx/src/classes/dialog.jsx";

export default function quotetemplateauditlog() {
    var loadQuoteTemplateAuditLogPage = function () {
        quosal.ui.react.render(<DialogManager />, document.getElementById('dialogManager'));
        quosal.ui.react.render(<QuoteTemplateAuditLog />, document.getElementById('currentDocument'));
        $('#pageName').val('quotetemplateauditlog.quosalweb');
    };
    quosal.sell.modules.onAfterLoad.unbind().bind(loadQuoteTemplateAuditLogPage);
}
